import { render, staticRenderFns } from "./FLoorForm.vue?vue&type=template&id=5e0f8faf&scoped=true"
import script from "./FLoorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FLoorForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FLoorForm.vue?vue&type=style&index=0&id=5e0f8faf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f8faf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0f8faf')) {
      api.createRecord('5e0f8faf', component.options)
    } else {
      api.reload('5e0f8faf', component.options)
    }
    module.hot.accept("./FLoorForm.vue?vue&type=template&id=5e0f8faf&scoped=true", function () {
      api.rerender('5e0f8faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/preventive-maintenance/list/items/FLoorForm.vue"
export default component.exports